import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { FaShippingFast, FaClock, FaGift } from "react-icons/fa"
import { supabase } from '../lib/supabaseClient.ts';
const iconMap = {
  FaShippingFast: <FaShippingFast size={32} color="#c71585" className="me-3" />,
  FaClock: <FaClock size={32} color="#c71585" className="me-3" />,
  FaGift: <FaGift size={32} color="#c71585" className="me-3" />,
};
function Find() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchFindCategory = async () => {
      const { data, error } = await supabase
        .from("find_category")
        .select("*")
        .order("order_index", { ascending: true });

      if (!error) setItems(data);
      else console.error(error);
    };

    fetchFindCategory();
  }, []);
  return (
    <>
     <div className="find-area py-4 ">
  <div className="container custom-container">
    <div className="row">
      <div className="col-12 ">
        <form>
          <div className="find-wrap" style={{ backgroundColor: "transparent",marginTop:"0px"}}>
            <div className="location"></div>

        <div className="find-category">
      <ul
        style={{
          padding: 0,
          margin: 0,
          listStyle: "none",
          backgroundColor: "#fcecde",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "1rem",
          borderRadius: "16px",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {items.map((item) => (
          <li
            key={item.id}
            style={{
              margin: 0,
              padding: "10px",
              backgroundColor: "#fcecde",
              display: "flex",
              flex: "1 1 280px",
              minWidth: "150px",
              maxWidth: "80%",
              borderRadius: "12px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              gap: "1rem",
            }}
          >
            <div style={{ flex: 1, paddingTop: "6px" }}>
              <div>
                {item.image_path ? (
                  <img
                    src={`https://<your-project>.supabase.co/storage/v1/object/public/animalia/${item.image_path}`}
                    alt={item.title}
                    style={{ width: 32, height: 32 }}
                  />
                ) : (
                  iconMap[item.icon_name] || null
                )}
              </div>
              <div>
                <h6 className="mb-1 fw-bold" style={{ fontSize: "1rem" }}>
                  {item.title}
                </h6>
                <small className="text-muted">{item.description}</small>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>

            <div className="other-find"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

    </>
  )
}

export default Find;
